/**
 * @enum - Segmentation Permission
 */

enum SegmentationPermission
{
    None = 0,
    Basic = 1,
    Push = 2,
    Power = 3
}

export default SegmentationPermission;